import { CommonModule } from '@angular/common';
import { Component, computed, input, output, Signal } from '@angular/core';
import { SortDirection } from '@webapp/core/stores/types';
import {
  BadgeComponent,
  IconComponent,
  IconTitleComponent,
  Status,
  UserBadgeComponent,
  IconType,
} from '@webapp/ui';
import { IQuoteRow } from '../../../interfaces/quotes.interface';
import { riskIconKey } from '@webapp/risk-core';
import { isUserType, USER_TYPES } from '@webapp/users/interfaces/users.interface';

@Component({
  selector: 'app-quotes-table',
  imports: [
    CommonModule,
    UserBadgeComponent,
    IconTitleComponent,
    BadgeComponent,
    IconComponent,
  ],
  templateUrl: './quotes-table.component.html',
  styleUrl: './quotes-table.component.scss',
})
export class QuotesTableComponent {
  readonly USER_TYPES = USER_TYPES;
  readonly isUserType = isUserType;
  entities = input<IQuoteRow[]>([]);
  showUser = input<boolean>(true);
  sortDirection: SortDirection = 'desc';
  showProducer = input<boolean>(true);

  Status = Status;

  viewDetail = output<IQuoteRow>();

  getIconName = (tag: string): IconType => riskIconKey(tag) as IconType;

  get rows(): Signal<IQuoteRow[]> {
    return computed(() => {
      const sortMultiplier = this.sortDirection === 'asc' ? 1 : -1;
      return this.entities().sort(
        (a, b) => (a.internalNumber - b.internalNumber) * sortMultiplier
      );
    });
  }

  toggleSort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  openQuoteDetail(quote: IQuoteRow) {
    this.viewDetail.emit(quote);
  }
}
